<template>
	<div
		class="view-in-chat"
		@click.stop="viewInChat()"
		v-t="'chat_message_viewinchat'"
	/>
</template>

<script>
export default {
	props: ['id', 'bubble_id'],

	methods: {
		viewInChat() {
			this.$router.push({
				name: 'chat',
				query: { centered: this.id },
			})

			EventBus.$emit('closeGroupSettings')
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.view-in-chat {
	font-family: 'Avenir-Medium';
	font-size: 14px;
	color: var(--blue-300);
	cursor: pointer;
	width: max-content;
	&:hover {
		color: darken($pronto-blue, 10%);
	}
}
</style>
